import { Composition } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Composition';
import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';

export class CompositionExtend {
  public static Init(dto: Composition) {
    dto.relationshipType = EnumRelationshipType.Composition;
    dto.sourceMultiplicity = EnumMultiplicity.One;
    dto.targetMultiplicity = EnumMultiplicity.ZeroMany;
  }
}
